module.exports = __webpack_public_path__ + "static/media/index-ad-img2.7c9618a3.jpg";